import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useMaterialUIController } from "context";
import { useUpgrade } from "context/upgrade";

// Tela exibida no lugar de uma rota premium quando o DJ é free (ex.: acesso direto pela URL).
// Não monta a tela real, então nenhuma chamada premium é feita.
function PremiumGate({ feature }) {
  const { openUpgrade } = useUpgrade();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={4} mb={3}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8} lg={6}>
            <Card>
              <MDBox p={4} textAlign="center">
                <Icon color="warning" sx={{ fontSize: "3rem !important" }}>lock</Icon>
                <MDTypography variant="h5" fontWeight="medium" mt={1}>
                  {feature} é um recurso Premium
                </MDTypography>
                <MDTypography variant="body2" color="text" mt={1} mb={3}>
                  Assine o Premium para organizar agenda, eventos, clientes e contratos em um só lugar.
                </MDTypography>
                <MDButton variant="gradient" color={sidenavColor} onClick={openUpgrade}>
                  Ver planos
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

PremiumGate.propTypes = {
  feature: PropTypes.string.isRequired,
};

export default PremiumGate;
